import type {FormikErrors} from 'formik';

export type Tab = {
  label: string;
  content: React.ReactNode;
  width?: string;

  // list of top level formik field names per tab
  // ideally this would be derived instead of passed in
  // but this would introduce a lot of complexity
  names: string[];
};

export function gotoValidationError(
  tabs: Record<string, Tab>,
  tabsList: string[],
  errors: FormikErrors<unknown>,
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
): void {
  const errorKeys = getStringOutOfHierarchy(errors);

  const firstTabWithError = tabsList.findIndex((id) =>
    tabs[id].names.find((name) => errorKeys.includes(name))
  );

  firstTabWithError >= 0 && setTabIndex(firstTabWithError);
}

// Function modified from:
// https://stackoverflow.com/questions/3294663/javascript-get-full-object-hierarchy-as-string
export function getStringOutOfHierarchy(
  obj: Record<string, unknown>
): string[] {
  let finalString: string[] = [];

  return recHierarchy(obj, Object.keys(obj));

  function recHierarchy(obj: unknown, initial?: string[]): string[] {
    // @ts-expect-error it's working
    if (Object.keys(obj).length !== 0) {
      const v: string[] = [];

      // @ts-expect-error it's working
      Object.keys(obj).forEach((elem) => {
        const baseString = elem;

        // @ts-expect-error it's working
        if (typeof obj[elem] === 'object' && !Array.isArray(obj[elem])) {
          v.push(elem);

          // @ts-expect-error it's working
          const returnedValue = recHierarchy(obj[elem]);
          const value = returnedValue.map(
            (elem) => `${baseString}.${elem.toString()}`
          );

          if (initial && initial.indexOf(elem) !== -1) {
            Array.isArray(value)
              ? (finalString = finalString.concat(...value))
              : (finalString = finalString.concat(value));
          }

          v.push(...value);
        } else {
          v.push(`${elem.toString()}`);
        }
      });

      return v;
    } else {
      return [''];
    }
  }
}
